// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Khrr","header":"MergedInvoice_header__3AHtC"};